import React from 'react';

export const BackgroundImage = (props) => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" viewBox="0 0 1464.266 677.531">
        <defs>
          <filter id="Rectángulo_1874" x="83" y="0" width="220.531" height="220.531" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur"/>
            <feFlood floodColor="#fff"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <filter id="Rectángulo_1880" x="220" y="201" width="220.531" height="220.531" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur-2"/>
            <feFlood floodColor="#fff"/>
            <feComposite operator="in" in2="blur-2"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <filter id="Rectángulo_1888" x="794.734" y="334" width="220.531" height="220.531" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur-3"/>
            <feFlood floodColor="#fff"/>
            <feComposite operator="in" in2="blur-3"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <filter id="Rectángulo_1882" x="588.735" y="457" width="220.531" height="220.531" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur-4"/>
            <feFlood floodColor="#fff"/>
            <feComposite operator="in" in2="blur-4"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <filter id="Rectángulo_1895" x="1183.266" y="149.74" width="106.164" height="107.051" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur-5"/>
            <feFlood floodColor="#fff"/>
            <feComposite operator="in" in2="blur-5"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <filter id="Rectángulo_1879" x="1203.265" y="423" width="117.859" height="117.859" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur-6"/>
            <feFlood floodColor="var(--primary)"/>
            <feComposite operator="in" in2="blur-6"/>
            <feComposite in="SourceGraphic"/>
          </filter>
        </defs>
        <g id="Grupo_3303" data-name="Grupo 3303" transform="translate(47.266 -65.734)">
          <g transform="matrix(1, 0, 0, 1, -47.27, 65.73)" filter="url(#Rectángulo_1874)">
            <g id="Rectángulo_1874-2" data-name="Rectángulo 1874" transform="translate(182.62 6) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="1">
              <rect width="144" height="144" rx="10" stroke="none"/>
              <rect x="0.5" y="0.5" width="143" height="143" rx="9.5" fill="none"/>
            </g>
          </g>
          <g transform="matrix(1, 0, 0, 1, -47.27, 65.73)" filter="url(#Rectángulo_1880)">
            <g id="Rectángulo_1880-2" data-name="Rectángulo 1880" transform="translate(319.62 207) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="1">
              <rect width="144" height="144" rx="10" stroke="none"/>
              <rect x="0.5" y="0.5" width="143" height="143" rx="9.5" fill="none"/>
            </g>
          </g>
          <g id="Rectángulo_1887" data-name="Rectángulo 1887" transform="translate(43.357 456.734) rotate(39)" fill="var(--primary)" stroke="#f6f9fb" strokeWidth="1" opacity="0.27">
            <rect width="144" height="144" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="143" height="143" rx="9.5" fill="none"/>
          </g>
          <g transform="matrix(1, 0, 0, 1, -47.27, 65.73)" filter="url(#Rectángulo_1888)">
            <g id="Rectángulo_1888-2" data-name="Rectángulo 1888" transform="translate(894.36 340) rotate(39)" fill="var(--primary)" stroke="#f6f9fb" strokeWidth="1" opacity="0.38">
              <rect width="144" height="144" rx="10" stroke="none"/>
              <rect x="0.5" y="0.5" width="143" height="143" rx="9.5" fill="none"/>
            </g>
          </g>
          <g id="Rectángulo_1889" data-name="Rectángulo 1889" transform="translate(1099.268 357.734) rotate(39)" fill="var(--primary)" stroke="#f6f9fb" strokeWidth="1" opacity="0.27">
            <rect width="91" height="91" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="90" height="90" rx="9.5" fill="none"/>
          </g>
          <g id="Rectángulo_1891" data-name="Rectángulo 1891" transform="translate(456.28 429.734) rotate(39)" fill="var(--primary)" stroke="#f6f9fb" strokeWidth="1" opacity="0.27">
            <rect width="91" height="91" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="90" height="90" rx="9.5" fill="none"/>
          </g>
          <g transform="matrix(1, 0, 0, 1, -47.27, 65.73)" filter="url(#Rectángulo_1882)">
            <g id="Rectángulo_1882-2" data-name="Rectángulo 1882" transform="translate(688.36 463) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="1">
              <rect width="144" height="144" rx="10" stroke="none"/>
              <rect x="0.5" y="0.5" width="143" height="143" rx="9.5" fill="none"/>
            </g>
          </g>
          <g id="Rectángulo_1894" data-name="Rectángulo 1894" transform="translate(1305.091 442.469) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="1">
            <rect width="144" height="144" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="143" height="143" rx="9.5" fill="none"/>
          </g>
          <g id="Rectángulo_1893" data-name="Rectángulo 1893" transform="translate(1029.622 270.734) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="1">
            <rect width="144" height="144" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="143" height="143" rx="9.5" fill="none"/>
          </g>
          <g transform="matrix(1, 0, 0, 1, -47.27, 65.73)" filter="url(#Rectángulo_1895)">
            <g id="Rectángulo_1895-2" data-name="Rectángulo 1895" transform="translate(1233.8 155.74) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="1">
              <rect width="60" height="66" rx="10" stroke="none"/>
              <rect x="0.5" y="0.5" width="59" height="65" rx="9.5" fill="none"/>
            </g>
          </g>
          <g id="Rectángulo_1875" data-name="Rectángulo 1875" transform="translate(198.357 172.734) rotate(39)" fill="var(--primary)" stroke="#f6f9fb" strokeWidth="1" opacity="0.26">
            <rect width="71" height="71" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="70" height="70" rx="9.5" fill="none"/>
          </g>
          <g id="Rectángulo_1876" data-name="Rectángulo 1876" transform="translate(32.357 272.57) rotate(39)" fill="#f1f7fb" stroke="#f6f9fb" strokeWidth="1" opacity="0.26">
            <rect width="71" height="71" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="70" height="70" rx="9.5" fill="none"/>
          </g>
          <g id="Rectángulo_1877" data-name="Rectángulo 1877" transform="translate(131.357 545.141) rotate(39)" fill="#f1f7fb" stroke="#f6f9fb" strokeWidth="1" opacity="0.26">
            <rect width="71" height="71" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="70" height="70" rx="9.5" fill="none"/>
          </g>
          <g id="Rectángulo_1883" data-name="Rectángulo 1883" transform="translate(159.965 318.904) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="4" opacity="0.63">
            <rect width="121" height="115" rx="10" stroke="none"/>
            <rect x="2" y="2" width="117" height="111" rx="8" fill="none"/>
          </g>
          <g id="Rectángulo_1884" data-name="Rectángulo 1884" transform="translate(310.372 511.904) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="4" opacity="0.63">
            <rect width="121" height="115" rx="10" stroke="none"/>
            <rect x="2" y="2" width="117" height="111" rx="8" fill="none"/>
          </g>
          <g id="Rectángulo_1885" data-name="Rectángulo 1885" transform="translate(1011.372 528.904) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="4" opacity="0.63">
            <rect width="121" height="115" rx="10" stroke="none"/>
            <rect x="2" y="2" width="117" height="111" rx="8" fill="none"/>
          </g>
          <g id="Rectángulo_1890" data-name="Rectángulo 1890" transform="translate(599.372 479.48) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="4" opacity="0.63">
            <rect width="121" height="115" rx="10" stroke="none"/>
            <rect x="2" y="2" width="117" height="111" rx="8" fill="none"/>
          </g>
          <g id="Rectángulo_1886" data-name="Rectángulo 1886" transform="translate(1254.372 172.904) rotate(39)" fill="none" stroke="#f6f9fb" strokeWidth="4" opacity="0.63">
            <rect width="121" height="115" rx="10" stroke="none"/>
            <rect x="2" y="2" width="117" height="111" rx="8" fill="none"/>
          </g>
          <g id="Rectángulo_1878" data-name="Rectángulo 1878" transform="translate(365.682 529.734) rotate(39)" fill="#f1f7fb" stroke="#f6f9fb" strokeWidth="1" opacity="0.26">
            <rect width="71" height="71" rx="10" stroke="none"/>
            <rect x="0.5" y="0.5" width="70" height="70" rx="9.5" fill="none"/>
          </g>
          <g transform="matrix(1, 0, 0, 1, -47.27, 65.73)" filter="url(#Rectángulo_1879)">
            <g id="Rectángulo_1879-2" data-name="Rectángulo 1879" transform="translate(1256.95 429) rotate(39)" fill="#037eb3" stroke="#f6f9fb" strokeWidth="1" opacity="0.55">
              <rect width="71" height="71" rx="10" stroke="none"/>
              <rect x="0.5" y="0.5" width="70" height="70" rx="9.5" fill="none"/>
            </g>
          </g>
        </g>
      </svg>
  );
};

BackgroundImage.propTypes = {}

BackgroundImage.defaultProps = {}

export default BackgroundImage;
